import React from "react";

function UploadDocPage() {
  return <div>UploadDocPage</div>;
}

export default UploadDocPage;
